import { render, staticRenderFns } from "./CubeProvider.vue?vue&type=template&id=432598b4"
import script from "./CubeProvider.vue?vue&type=script&lang=js"
export * from "./CubeProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports